import { styled } from '@mui/system'
import { Grid } from '@mui/material'

export const GridWithMargin = styled(Grid)({
  marginTop: '20px',
  marginLeft: '20px',
  marginRight: '20px',
})
